import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Input, message, Modal, Radio } from 'antd';
import { useState } from 'react';
import RolePermissions from '../../containers/dashboard/team-members/role-permissions';
import teamMembersService from '../../services/team-members.service';

export const TeamMemberInvitationForm: React.FC<any> = ({ visible, onCancel, onAdd, onAddError }) => {
	const [form] = Form.useForm();

	const roles = [
		{ label: 'Admin', value: 'company_admin' },
		{ label: 'User', value: 'company_user' }
	];

	const [errors, setErrors] = useState<any>({});
	const [rolePermissionsModalVisible, setRolePermissionsModalVisible] = useState(false);

	const onFinish = async values => {
		let resp;
		try {
			resp = await teamMembersService.inviteTeamMember(values);
			if (!resp || !resp.success) throw new Error(resp.message || 'Something went wrong');
		} catch (e: any) {
			console.error(e);
			message.error(e.message);
			onAddError && onAddError(e);
			setErrors(e.errors || {});
			return;
		}
		onAdd && onAdd(resp.data);
		setErrors({});
		form.resetFields();
	};

	const rolePermissionHandler = e => {
		e.preventDefault();
		setRolePermissionsModalVisible(true);
	};
	return (
		<>
			<Modal
				className="ta-modal"
				title="Team member invitation"
				visible={visible}
				onCancel={onCancel}
				onOk={form.submit}
				okText="Invite"
			>
				<Form
					layout="horizontal"
					className="ta-form"
					labelCol={{ xs: { span: 24 }, xl: { span: 8 } }}
					wrapperCol={{ xs: { span: 24 }, xl: { span: 16 } }}
					labelAlign="left"
					form={form}
					onFinish={onFinish}
				>
					<Form.Item
						label="E-mail Address"
						hasFeedback
						help={errors.email?.message}
						validateStatus={errors.email && 'error'}
						name="email"
						rules={[
							{
								required: true,
								message: 'You must provide the E-mail Address'
							},
							{ type: 'email', message: 'Invalid email address.' }
						]}
					>
						<Input type="text" placeholder="Enter the team member E-mail address" />
					</Form.Item>

					<Form.Item
						label="Role"
						help={errors.role?.message}
						validateStatus={errors.role && 'error'}
						name="role"
						rules={[
							{
								required: true,
								message: 'You must provide the team member role'
							}
						]}
					>
						<Radio.Group options={roles} />
					</Form.Item>
				</Form>
				<a
					href=""
					className="d-flex align-items-center"
					style={{ fontSize: '14px' }}
					onClick={rolePermissionHandler}
				>
					<InfoCircleOutlined className="me-1" />
					View role permissions
				</a>
			</Modal>
			<RolePermissions
				visible={rolePermissionsModalVisible}
				onCancel={() => setRolePermissionsModalVisible(false)}
			/>
		</>
	);
};
